// Setup canvas
let Canvas, ctx, BufferCanvas, bctx;

// Wave params
const cycles = 2; // cycles across the width

// Sampling/drawing params
let lastTime = performance.now();
const samples = 220; // line smoothness
const phaseSpeed = 2.5; // radians per second

// Particle spawning
const particles = []; // array to hold particles
const spawnEverySec = 0.3; // particle spawn rate
let spawnAcc = 0; // spawn accumulator

// Particle "tail" params
const tailMaxLenFactor = 3; // max tail length in radii (n distance)
const tailSnapSpeed = 20; // how fast it retracts after peak (1/sec)
const tailVyForMax = 600.0; // vy at which tail is considered “maxed”
const tailMinDraw = 0.5; // px; don't bother with micro-tails

// Particle speed params
// const vx = 80 + Math.random() * 120; // base horizontal speed (80–200)
const slopeLookAhead = 8; // in pixels; looking ahead at slope
const slopeSpeedStrength = 2; // how strong the slope affects speed
const vxMinFactor = 0.1; // min speed relative to base speed
const vxMaxFactor = 1.5; // max speed relative to base

// Particle settling params
const settleSlopeEps = 0.03; // how flat is "flat enough"
const settleCurveMin = 0.0005; // how "valley-ish"
const settleDamping = 0.7; // slows vx while settling
const surfaceOvershootFactor = -0.2; // how far past the center line the particle "hangs" before dropping
const particleVerticalOffsetEase = 2.0; // easing
const particleVerticalOffsetFollow = 6.0; // how fast the offset "chases" the target

// Colors
const COLOR_DEFAULT = "rgba(180, 0, 20, 1)";
let COLOR_FLUID = COLOR_DEFAULT; // fallback color, can be overridden by init options

const state = {
    x: 0,
    y: 0,
    width: null,
    height: null,
    midYLeft: null,
    midYRight: null,
    phase: 0, // radians
    amp: 10, // amplitude (px)
    ampA: 10, // endpoint A
    ampB: 20, // endpoint B
    ampHz: 0.5, // oscillations per second (cycles/sec)
    ampOscOn: true,
    ampTime: 0, // oscillator time accumulator (seconds)

    markers: [],

    gravity: 1200, // px/sec^2
};


function lerp(a, b, t) {
    return a + (b - a) * t;
}

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

// Spawn particles
function spawnParticle() {
    const vx = 80 + Math.random() * 100; // base horizontal speed (80–200)
    const x = state.width * 0.45 + Math.random() * state.width;
    const y = yAt(x);
    const minRadius = 5 + Math.random() * 10;
    const maxRadius = 15 + Math.random() * 20;
    const maxTailLength = minRadius * tailMaxLenFactor;

    particles.push({
        x,
        y,
        vx,
        vxBase: vx,
        vy: 0,
        yOffset: -minRadius,
        r: minRadius,
        r0: minRadius,
        growth: 1 + Math.random() * 5,
        maxR: maxRadius,
        state: "onWave",
        totalSettleTime: 0,

        // Tail values
        tailLength: 0,
        tailRetracting: false,
        maxTailLength,

        // settle config/state
        settleTimer: 0,
        settleDelay: 0.2 + Math.random() * 0.3, // seconds to "rest" before dropping
    });
}

// Get y value of the waveform at a given x
function yAt(x) {
    const t = x / state.width; // 0 to 1 across the canvas; gets the current interpolated position relative to the width of the canvas

    // linear interpolation of the "baseline"
    const baseline = lerp(state.midYLeft, state.midYRight, t);

    return (
        baseline + state.amp * Math.sin(Math.PI * 2 * cycles * t + state.phase)
    );
}

// Get slope (dy/dx) of the waveform at a given x
function slopeAt(x) {
    const dx = 1; // px
    return (yAt(x + dx) - yAt(x - dx)) / (2 * dx); // dy/dx
}

// Get curvature (d²y/dx²) of the waveform at a given x
function curvatureAt(x) {
    const dx = 2; // px
    // second derivative approx: y(x+dx) - 2y(x) + y(x-dx)
    return (yAt(x + dx) - 2 * yAt(x) + yAt(x - dx)) / (dx * dx);
}

function drawWaveFillShape(context, colorString) {
    context.fillStyle = colorString;
    context.beginPath();
    // ... top edge
    context.moveTo(0, 0);
    context.lineTo(state.width, 0);

    // ... right edge
    context.lineTo(state.width, yAt(state.width));

    // ... bottom edge (dynamic/wave-y)
    for (let i = samples; i >= 0; i--) {
        const x = (state.width * i) / samples;
        const y = yAt(x);
        context.lineTo(x, y);
    }

    // ... close path (back to top left)
    context.closePath();

    context.fill();
}

function drawTail(particleObject, context, px, py) {
    const halfBase = particleObject.r; // radius
    const baseY = py;
    const apexX = px;
    const apexY = py - (particleObject.r + particleObject.tailLength); // apex starts r (radius) above base then stretches upward

    context.beginPath();
    context.moveTo(px - halfBase, baseY);
    context.lineTo(px + halfBase, baseY);
    context.lineTo(apexX, apexY);
    context.closePath();
    context.fill();
}

function drawParticles(context, colorString) {
    context.fillStyle = colorString;

    for (const p of particles) {
        const px = p.x;
        const py = p.y;

        if (p.state === "drop" && p.tailLength > 0.5) {
            drawTail(p, context, px, py);
        }

        context.beginPath();
        context.arc(px, py, p.r, 0, Math.PI * 2);
        context.fill();
    }
}

function renderLiquid(context, colorString) {
    // draw Fill
    drawWaveFillShape(context, colorString);

    // draw ALL particles
    drawParticles(context, colorString);
}

function draw() {

    bctx.clearRect(0, 0, state.width, state.height);

    // draw Fill and particle "Drips"
    renderLiquid(bctx, COLOR_FLUID);

    // draw buffer to visible canvas
    ctx.clearRect(0, 0, state.width, state.height);
    ctx.drawImage(BufferCanvas, 0, 0);
}

function easeParticleYPosition(particleObject, delta) {
    const waveY = yAt(particleObject.x);
    // progress values ("u")
    const uRaw =
        (particleObject.r - particleObject.r0) /
        (particleObject.maxR - particleObject.r0);
    const u = clamp(uRaw, 0, 1);

    // ease "hang"
    const eased = Math.pow(u, particleVerticalOffsetEase);

    // offset; start at -r (radius), end at +overshoot (surfaceOvershootFactor)
    const startOffset = -particleObject.r; // radius above line
    const endOffset = particleObject.r * surfaceOvershootFactor; // a little past the line

    const targetOffset = lerp(startOffset, endOffset, eased);

    particleObject.yOffset +=
        (targetOffset - particleObject.yOffset) *
        (1 - Math.exp(-particleVerticalOffsetFollow * delta));
    particleObject.y = waveY + particleObject.yOffset;
}

function updateTail(particleObject, delta) {
    // const maxTailLength = particleObject.r * tailMaxLenFactor;

    // progress value ("u")
    const u = clamp(particleObject.vy / tailVyForMax, 0, 1);
    const targetTailLength = particleObject.maxTailLength * u;

    if (!particleObject.tailRetracting) {
        // grow the tail at the fall rate
        // using `.abs()` as future proof for direction
        particleObject.tailLength += Math.abs(particleObject.vy) * delta;

        // clamp/switch to snap-back once Max is reached
        if (particleObject.tailLength >= particleObject.maxTailLength) {
            particleObject.tailLength = particleObject.maxTailLength;
            particleObject.tailRetracting = true;
        }
    } else {
        // snap-back fast — simulate return of surface tension
        particleObject.tailLength *= Math.exp(-tailSnapSpeed * delta);

        // stop when (essentially) gone
        if (particleObject.tailLength < tailMinDraw) {
            particleObject.tailLength = 0;
        }
    }

    // // start snapping back
    // if( !particleObject.tailRetracting && u >=0.95 ){
    //   particleObject.tailRetracting = true;
    // }

    // // stretch until snap-back
    // const k = particleObject.tailRetracting ? tailSnapSpeed : tailStretchSpeed;
    // particleObject.tailLength += ( targetTailLength - particleObject.tailLength ) * ( 1 - Math.exp( -k * delta ) );

    // // reset
    // if (particleObject.tailRetracting && particleObject.tailLength < maxTailLength * 0.15) {
    //   particleObject.tailRetracting = false;
    // }
}

function update(delta) {
    // do calculations to update state here

    // spawn particles
    spawnAcc += delta;
    while (spawnAcc >= spawnEverySec) {
        spawnParticle();
        spawnAcc -= spawnEverySec;
    }

    //    state.phase += 0.03; // speed (fixed)
    state.phase += phaseSpeed * delta; // speed based on time

    // amplitude oscillator
    if (state.ampOscOn) {
        state.ampTime += delta;

        // Convert Hz -> radians/sec for the oscillator:
        const omega = Math.PI * 2 * state.ampHz;

        // sin gives -1..1. Convert to 0..1:
        const u = (Math.sin(state.ampTime * omega) + 1) / 2;

        // map u between ampA and ampB
        state.amp = state.ampA + (state.ampB - state.ampA) * u;
    }

    // move ALL the particles
    for (const p of particles) {
        // grow while on the wave
        if (p.state === "onWave") {
            // calculate effect of slope on speed
            const sAhead = slopeAt(p.x + slopeLookAhead);

            // if multiplier (`sAhead`) > 1, the particle is moving downhill
            // if multiplier (`sAhead`) < 1, the particle is moving uphill
            let factor = 1 + sAhead * slopeSpeedStrength;

            // clamp factor
            factor = clamp(factor, vxMinFactor, vxMaxFactor);

            // move the particle with speed influenced by slope
            p.x += p.vxBase * factor * delta;

            p.r += p.growth * delta;

            // ease-in relative to wave
            easeParticleYPosition(p, delta);

            // when max size reached, start settling instead of dropping immediately
            if (p.r >= p.maxR) {
                p.r = p.maxR;
                p.state = "settle";
                p.settleTimer = 0;
                p.totalSettleTime = 0;
            }
        } else if (p.state === "settle") {
            // stay on wave, but slow down
            p.vxBase *= Math.pow(settleDamping, delta * 60); // frame-rate-ish independent damping
            p.x += p.vxBase * delta;

            // p.y = yAt(p.x); // old, "glued to waveform" value
            easeParticleYPosition(p, delta);

            // detect valley: slope ~ 0 and curvature indicates a minimum
            const s = slopeAt(p.x);
            const k = curvatureAt(p.x);

            // accumulate total time trying to settle
            p.totalSettleTime += delta;

            const nearFlat = Math.abs(s) < settleSlopeEps;
            const isValley = k > settleCurveMin;

            if (nearFlat && isValley) {
                p.settleTimer += delta;
                if (p.settleTimer >= p.settleDelay) {
                    p.state = "drop";
                    p.vy = 0;
                }
            } else {
                // not settled yet, reset timer
                p.settleTimer = 0;
            }

            // failsafe: if we’ve been trying to settle for too long, drop anyway
            if (p.totalSettleTime > 1.5) {
                p.state = "drop";
                p.vy = 0;
            }
        } else if (p.state === "drop") {
            // optional: keep drifting horizontally a bit while falling
            p.x += p.vx * delta * 0.15;

            // gravity fall
            p.vy += state.gravity * delta;
            p.y += p.vy * delta;

            // render/update the "tail"
            updateTail(p, delta);
        }
    }

    // remove particles that are off-screen (or too big)
    for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        if (p.x > state.width + p.r || p.x < -p.r || p.y > state.height + p.r) {
            particles.splice(i, 1);
        }
    }
}

function loop(now) {
    const delta = (now - lastTime) / 1000; // convert ms → seconds
    lastTime = now;

    update(delta);
    draw();

    requestAnimationFrame(loop);
}

function resize() {
    Canvas.width = Canvas.clientWidth;
    Canvas.height = Canvas.clientHeight;

    BufferCanvas.width = Canvas.width;
    BufferCanvas.height = Canvas.height;

    state.width = Canvas.width;
    state.height = Canvas.height;
}

function setupCanvas(canvas) {
    // Setup DOM canvas
    Canvas = canvas;
    state.width = Canvas.width;
    state.height = Canvas.height;
    ctx = Canvas.getContext("2d");

    // Setup buffer canvas
    BufferCanvas = document.createElement("canvas");
    BufferCanvas.width = state.width;
    BufferCanvas.height = state.height;
    bctx = BufferCanvas.getContext("2d");

    // Initial state values that depend on canvas size
    state.width = Canvas.width;
    state.height = Canvas.height;
    state.midYLeft = Canvas.height * -0.2; // higher on the left
    state.midYRight = Canvas.height * 0.2; // lower on the right
}

// Init
function init( { canvas, color } = {} ) {
    // console.log("Waveform JS", { clamp, lerp, state });
    if ( !canvas ) {
        console.warn("No canvas provided for InitLiquid");
        return;
    }

    setupCanvas( canvas );

    if (color) {
        COLOR_FLUID = color;
    }


    window.addEventListener("resize", resize);
    resize();

    state.amp = state.ampA; // artifact

    requestAnimationFrame(loop);
}

export { init as InitLiquid };